import { useMemo } from "react";
import sanitizeHtml from "sanitize-html";

export const ChangelogContent = ({ html }: { html: string }) => {
  const sanitized = useMemo(
    () =>
      sanitizeHtml(html, {
        allowedTags: [
          "div",
          "p",
          "br",
          "strong",
          "em",
          "b",
          "i",
          "u",
          "a",
          "ul",
          "ol",
          "li",
          "h3",
          "h4",
          "h5",
          "h6",
          "blockquote",
          "pre",
          "code",
          "figure",
          "figcaption",
          "img",
          "del",
          "s",
          "hr",
        ],
        allowedAttributes: {
          "*": ["class"],
          a: ["href", "title", "rel"],
          img: ["src", "alt", "title", "width", "height"],
        },
        allowedClasses: {
          "*": [
            "trix-content",
            "attachment",
            "attachment--preview",
            "attachment__caption",
            "attachment-gallery",
          ],
        },
        allowedSchemes: ["http", "https", "mailto"],
        allowedSchemesByTag: { img: ["http", "https"] },
        allowProtocolRelative: false,
        transformTags: {
          h1: "h3",
          h2: "h3",
          a: sanitizeHtml.simpleTransform("a", { rel: "noopener noreferrer" }),
        },
      }),
    [html],
  );

  return (
    <section
      className="typeset typeset-document min-w-0"
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};
